import styled from "styled-components";
import {
  GoogleMap,
  useLoadScript,
  Marker,
  DirectionsRenderer,
  InfoWindow,
} from "@react-google-maps/api";
import { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { setRouteDistance } from "../../../features/addLoad/addLoadSlice";
import { useSelector } from "react-redux";
import driverIcon from "../../../images/svg/map/driver-marker.svg";
import circle from "../../../images/svg/map/circle.svg";

const Container = styled.div`
  width: 100%;
`;

const GivenMapSection = ({
  defaultLocation,
  route,
  zoom,
  item,
  shipmentLocations,
  driverLocation,
  isLocation = true,
  sonGorulme
}) => {

  const { userData } = useSelector((state) => state.user);
  const dispatch = useDispatch();

  const [driverResponse, setDriverResponse] = useState(null);
  const [selectedItem, setSelectedItem] = useState(null);
  const [driverLastDate, setDriverLastDate] = useState(null)

  const [directionsResponse, setDirectionsResponse] = useState(null);
  const [map, setMap] = useState(null);

  const { isLoaded } = useLoadScript({
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_API_KEY,
  });


  const rotaOptions = {
    polylineOptions: {
      strokeColor: "#2855F5", // Rota rengi
      strokeOpacity: 1,
      strokeWeight: 3,
    },
  };

  //! sürücü rota
  const driverOptions = {
    suppressMarkers: true,
    polylineOptions: {
      strokeColor: "#E85446",
      strokeOpacity: 1,
      strokeWeight: 3,
    },
  };

  const onLoad = (mapInstance) => {
    setMap(mapInstance);
  };

  useEffect(() => {
    if (map) {
      // eslint-disable-next-line no-undef
      const mapCenter = new window.google.maps.LatLng(
        defaultLocation.lat,
        defaultLocation.lng
      );
      map.panTo(mapCenter); // Marker'ın bulunduğu bölgeye odaklanmak için panTo kullanıyoruz
    }
  }, [map]);

  const options = {
    zoomControl: false, // Zoom butonlarını kaldırır
    // fullscreenControl: false, // Tam ekran kontrolünü kaldırır
    streetViewControl: false, // Sokak görünümü kontrolünü kaldırır
    scaleControl: false, // Ölçek kontrolünü kaldırır
    mapTypeControl: false, // Harita türü kontrolünü kaldırır
    rotateControl: false, // Döndürme kontrolünü kaldırır
    // panControl: false, // Kaydırma kontrolünü kaldırır
  };

  useEffect(() => {
    if (map && route?.length > 1) {
      calculateRoute(route);
    } else {
      setDirectionsResponse(null);
    }
  }, [map, route]);

  //! sürücü rotası
  useEffect(() => {
    if (map && shipmentLocations) {
      calculateDriverRoute(shipmentLocations);
    }
  }, [map, shipmentLocations]);

  const calculateRoute = async (route) => {
    const origin = route[0];
    const destination = route[route.length - 1];
    const wayPoints = route.slice(1, route.length - 1);
    // eslint-disable-next-line no-undef
    const directionsService = new google.maps.DirectionsService({
      // DragEvent
    });

    const results = await directionsService.route({
      origin: { lat: parseFloat(origin.lat), lng: parseFloat(origin.lng) },
      destination: { lat: parseFloat(destination.lat), lng: parseFloat(destination.lng) },
      // eslint-disable-next-line no-undef
      travelMode: google.maps.TravelMode.DRIVING,
      waypoints: wayPoints.length > 0 ? wayPoints : null,
    });

    setDirectionsResponse(results);
    dispatch(
      setRouteDistance(
        results.routes[0].legs.reduce((accumulator, item) => {
          return accumulator + parseFloat(item.distance.text.replace(".", ""));
        }, 0)
      )
    );
  };

  //! sürücü rotası
  const calculateDriverRoute = async (route) => {
    const origin = route[0];
    const destination = route[route.length - 1];
    const wayPoints = route.slice(1, route.length - 1);
    // eslint-disable-next-line no-undef
    const directionsService = new google.maps.DirectionsService({
      // DragEvent
    });
  
    const results = await directionsService.route({
      origin: { lat: parseFloat(origin.lat.replace(",", ".")), lng: parseFloat(origin.lng.replace(",", ".")) },
      destination: {
        lat: parseFloat(destination.lat.replace(",", ".")),
        lng: parseFloat(destination.lng.replace(",", ".")),
      },
      // eslint-disable-next-line no-undef
      travelMode: google.maps.TravelMode.DRIVING,
      waypoints:  wayPoints.length > 0 ? wayPoints.map((item) => {
                  return {
                        location: {
                          lat: parseFloat(item.lat.replace(",", ".")),
                          lng: parseFloat(item.lng.replace(",", ".")),
                        },
                      };
                    })
                  : null,
    });

    setDriverResponse(results);

    dispatch(
      setRouteDistance(
        results.routes[0].legs.reduce((accumulator, item) => {
          return accumulator + parseFloat(item.distance.text.replace(".", ""));
        }, 0)
      )
    );
  };

  if (!isLoaded) {
    return <div>loading</div>;
  }

  const splitDateAndTime = (createdDate) => {
    const [datePart, timePart] = createdDate.split('T');
    const timeComponents = timePart.split('.');
    const time = new Date(`${datePart}T${timeComponents[0]}`); 
  
    const newTime = new Date(time);
    newTime.setHours(newTime.getHours() + 3);
  
    const trTime = newTime.toLocaleTimeString('tr-TR', { hour: '2-digit', minute: '2-digit', second: '2-digit' });
    const [year, month, day] = datePart.split('-');
    const formattedDate = `${day}-${month}-${year}`;

    return {
      date: formattedDate,
      time: trTime,
    };
  };
  
  const onDriverMarkerClick = (latitude, longitude) => {
    setDriverLastDate({ lat: latitude, lng: longitude });
  };



  return (
    <Container>
      <GoogleMap
        zoom={zoom}
        mapContainerClassName="map-container"
        onLoad={onLoad}
        options={options}
      >
        {directionsResponse && isLocation && (
          <DirectionsRenderer
            suppressMarkers={true}
            directions={directionsResponse}
            options={rotaOptions}
            draggable={true}
            onDragEnd={(newDirections) => setDirectionsResponse(newDirections)}
          />
        )}

        {driverResponse && driverLocation && (
          <DirectionsRenderer
            directions={driverResponse}
            options={driverOptions}
            draggable={true}
            onDragEnd={(newDirections) => setDriverResponse(newDirections)}
          />
        )}
        {userData?.latitude !== undefined &&
          userData?.longitude !== undefined &&
          item?.stateOfShipment !== 3 && (
            <Marker
              icon={driverIcon}
              position={{ lat: userData?.latitude, lng: userData?.longitude }}
              onClick={() => onDriverMarkerClick(userData?.latitude, userData?.longitude)}
            />
          )}

          {driverLastDate && (
            <InfoWindow
              position={driverLastDate}
              onCloseClick={() => setDriverLastDate(null)}
            >
              <div>
                <p>Son Görülme</p>
                <p>{sonGorulme}</p>
              </div>
            </InfoWindow>
          )}


         {shipmentLocations && driverLocation && 
            <>
              {shipmentLocations.map((item)=>{
                return(
                  <>
                    <Marker onClick={() => setSelectedItem(item)} icon={circle} position={{lat: parseFloat(item?.lat), lng:parseFloat(item?.lng) }} /> 
                  </>
              )})}
            </> 
            } 

            {selectedItem && (
                <InfoWindow
                  position={{ lat: parseFloat(selectedItem?.lat), lng: parseFloat(selectedItem?.lng) }}
                  onCloseClick={() => setSelectedItem(null)}
                >
                  <div style={{display:"flex", alignItems:"center", flexDirection:"column"}}>
                    {/* <p>{selectedItem?.name}</p> */}
                    <p>{splitDateAndTime(selectedItem?.createdDate).date}</p>
                    <p>{splitDateAndTime(selectedItem?.createdDate).time}</p>
                  </div>
                </InfoWindow>
            )}
      </GoogleMap>
    </Container>
  );
};

export default GivenMapSection;
